import { EntityStatus, ServiceInstanceActions } from "../Constants/Constants";

/**
 * @param {*} data : response from get all instance api for given service id
 * @returns Array of objects as required by service instance table
 */
export const convertServiceInstanceList = (data) => {
  const list = data.instances ? data.instances : [];
  return list.map((item) => {
    return {
      key: item.instanceid,
      instanceId: item.instanceid,
      name: item.instancename,
      maturity: item.maturitystate,
      version: item.version,
      status: item.instancestatus,
      location: item.location,
      serviceName: item.servicename,
    };
  });
};

/**
 * @param {*} data : service instance form submitted values
 * @param {*} action : action type: add or edit
 * @returns Object formatted as required by create or update api
 */
export const convertInstanceFormToApiValues = (
  data,
  action = ServiceInstanceActions.add
) => {
  const returnData = {
    maturitystate: data.maturity,
    location: {
      name: data.locationName,
      value: data.locationValue,
    },
    serviceid: data.serviceId,
    version: data.version,
  };

  if (action === ServiceInstanceActions.add) {
    returnData.instancename = data.name;
    returnData.instancestatus = EntityStatus.ACTIVE;
  }
  if (action === ServiceInstanceActions.edit) {
    returnData.instanceid = data.instanceId;
  }
  return returnData;
};
